"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = exports.Container = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion");

var Container = (0, _styled.default)(_framerMotion.motion.div)(function (_ref) {
  var direction = _ref.direction,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      nav = _ref$theme.nav,
      space = _ref$theme.space;
  return {
    backgroundColor: colors[nav.backgroundColor],
    boxShadow: nav.boxShadow,
    position: 'absolute',
    bottom: 0,
    transform: "translateY(calc(100% + ".concat(space.small, "))"),
    left: direction === 'left' ? 0 : 'auto',
    right: direction === 'right' ? 0 : 'auto',
    padding: "".concat(space.medium, " ").concat(space.xlarge),
    borderRadius: space.small,
    zIndex: 100
  };
});
exports.Container = Container;
var Wrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      space = _ref2$theme.space,
      width = _ref2.width;
  return {
    width: width,
    height: 'auto',
    maxHeight: '42rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      left: 0,
      top: "-".concat(space.small),
      backgroundColor: 'transparent',
      height: space.small
    },
    '& > div:last-of-type': {
      marginBottom: space.medium,
      marginTop: space.medium,
      paddingTop: space.large,
      borderTop: "1px solid ".concat(colors.greymid)
    },
    overflowY: 'auto',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;